import ConsoleLogger, {
    configure,
} from './ConsoleLogger';

export {
    ConsoleLogger,
    configure,
};

export default {
    ...ConsoleLogger,
    configure,
};
